import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { InformasiAkunPage } from './informasi-akun/informasi-akun.page';
import { ResetPasswordPage } from './reset-password/reset-password.page';
import { PrivacyPolicyPage } from './privacy-policy/privacy-policy.page';
import{ApiService} from '../services/api.service';
import { AlertController } from '@ionic/angular';
import { Router, ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-tab4',
  templateUrl: 'tab-account.page.html',
  styleUrls: ['tab-account.page.scss']
})
export class TabAccountPage {

	constructor(private modalCtrl:ModalController, private navCtrl:NavController, private api:ApiService, private alert:AlertController, private router:Router) { }

  ngOnInit() {
    this.getUserData();
  }

  ionViewDidEnter(){      
    this.getUserData();
  }

  userData:any={};
  getUserData()
  {
    this.api.data('user/me','get','').subscribe(data=>{
        this.userData=data;
    })
  }


   async logout(id) {
    const alert = await this.alert.create({
      header: 'Keluar',
      message: 'Anda yakin akan keluar dari akun Anda?',
      buttons: [
        {
          text: 'Batal',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            return false;
          }
        }, {
          text: 'YA',
          handler: () => {
            localStorage.removeItem('goopitoken');
            location.reload();
          }
        }
      ]
    });
    await alert.present();
  }

  async modalAkun() {
    const modal = await this.modalCtrl.create({
      component: InformasiAkunPage,
    });
    return await modal.present();
  }

  async modalReset() {
    const modal = await this.modalCtrl.create({
      component: ResetPasswordPage,
    });
    return await modal.present();
  }

  async modalPrivacy() {
    const modal = await this.modalCtrl.create({
      component: PrivacyPolicyPage,
    });
    return await modal.present();
  }

}
